module.exports = __webpack_public_path__ + "static/media/aventura-mall-in-america.00605449.jpg";